<template>
  <label v-if="label" class="label" :class="{'has-subtitle':sub}">
    {{ label }}
    <template v-if="sub">
      <br><small>{{ sub }}</small>
    </template>
  </label>
</template>

<script>
  export default {
    name: "FieldLabel",
    props: {
      label: {
        type: String,
        default: null,
      },
      sub: {
        type: String,
        default: null,
      }
    }
  }
</script>

<style scoped>

</style>